import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { gdprManager } from '../../../../services/GdprMananger'
import UserManager from '../../../../services/UserManager'
import * as EmailValidator from 'email-validator'
import LongRightArrowIcon from '../../../../icons/assets/LongRightArrow.svg'
import SuccessIcon from '../../../../icons/assets/Success.svg'
import * as S from './EmailSignupSection.styles'

export default function EmailSignupSection() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [hasError, setHasError] = useState(false)

  const handleButtonClick = async () => {
    if (!email.trim() || isSubmitting) return

    if (!EmailValidator.validate(email)) {
      setHasError(true)
      return
    }

    setIsSubmitting(true)
    try {
      await UserManager.setUserEmail({
        email,
        source: 'footer',
        refetchExperiments: false,
        onboardingFlow: null,
        emailConsent: true,
      })

      // Track the consent event for marketing purposes
      gdprManager.setMarketingConsentGiven('footer', email)
      UserManager.setExplicitEmailConsent(email, true)

      setShowSuccessMessage(true)
      setEmail('')
    } catch (_error) {
      // Shouldnt really fail,
    } finally {
      setIsSubmitting(false)
    }
  }

  if (showSuccessMessage) {
    return (
      <S.Container>
        <S.SuccessContainer>
          <S.SuccessIconContainer>
            <img src={SuccessIcon} alt="Success" />
          </S.SuccessIconContainer>
          <S.SuccessMessage>
            {t('homepage.email_signup.success_message')}
          </S.SuccessMessage>
        </S.SuccessContainer>
      </S.Container>
    )
  }

  return (
    <S.Container>
      <S.ContentContainer>
        <S.Title>{t('homepage.email_signup.title')}</S.Title>
        <S.InputSection>
          <S.InputContainer $hasError={hasError}>
            <S.InputWrapper>
              <S.InputLabel
                $hasValue={!!email || isFocused}
                data-testid="email-label"
              >
                {t('homepage.email_signup.email_label')}
              </S.InputLabel>
              <S.EmailInput
                type="email"
                placeholder=""
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setEmail(e.target.value)
                  if (hasError) setHasError(false) // Clear error when user starts typing
                }}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                disabled={isSubmitting}
                $hasError={hasError}
                data-testid="email-input"
                autoComplete="email"
              />
            </S.InputWrapper>
            {email && (
              <S.SubmitButton
                type="button"
                onClick={handleButtonClick}
                disabled={!email.trim() || isSubmitting}
              >
                <img src={LongRightArrowIcon} alt="Submit" />
              </S.SubmitButton>
            )}
          </S.InputContainer>
          <S.DynamicContentWrapper $isVisible={!!email}>
            <S.TermsText>{t('homepage.email_signup.terms_text')}</S.TermsText>
          </S.DynamicContentWrapper>
        </S.InputSection>
      </S.ContentContainer>
    </S.Container>
  )
}
